import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

export const APP_SCREENS = [
  { src: "/app-screens/espace-proprietaire.webp", title: "Espace propriétaire", desc: "Contrat Protection Habitat, interventions incluses et l'assistant IA intégré" },
  { src: "/app-screens/catalogue.webp", title: "Le catalogue des prestations", desc: "Tout corps d'état avec le prix de départ affiché : plomberie, électricité, serrurerie, chauffage…" },
  { src: "/app-screens/prestation-detail.webp", title: "Le prix avant de confirmer", desc: "Fourchette de prix, durée moyenne, garantie 48h, inclus / non inclus — tout est écrit" },
  { src: "/app-screens/dashboard.webp", title: "Votre tableau de bord", desc: "Rappels de devis, promos et suivi du Contrat Protection Habitat" },
  { src: "/app-screens/suivi-demandes.webp", title: "Suivi en direct", desc: "Chaque demande suivie étape par étape, fidélité et statistiques" },
  { src: "/app-screens/devis.webp", title: "Mes devis", desc: "Les offres arrivent dans l'application : comparer, choisir, payer" },
  { src: "/app-screens/techniciens.webp", title: "Nos techniciens", desc: "Des professionnels assurés et notés par les clients" },
  { src: "/app-screens/partenaires.webp", title: "Partenaires", desc: "Réductions exclusives réservées aux abonnés" },
  { src: "/app-screens/marche-immo.webp", title: "Marché Immo", desc: "Vendre, louer ou rechercher un bien entre abonnés" },
  { src: "/app-screens/compte.webp", title: "Mon compte", desc: "Factures, données RGPD, parrainage et documents réunis" },
];

export default function AppScreensGallery({ testid = "app-screens-gallery" }) {
  return (
    <div data-testid={testid} className="relative">
      <div className="-mx-5 overflow-x-auto px-5 pb-4 lg:-mx-8 lg:px-8 [scrollbar-width:thin]">
        <div className="flex gap-6">
          {APP_SCREENS.map((s, i) => (
            <motion.figure
              key={s.src}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: (i % 4) * 0.08, duration: 0.6 }}
              className="w-[220px] flex-shrink-0 sm:w-[240px]"
              data-testid={`app-screen-${i}`}
            >
              <div className="overflow-hidden rounded-[2rem] border border-white/10 bg-navy-elevated p-2 shadow-xl shadow-black/40">
                <img src={s.src} alt={`Application Speed Détresse — ${s.title}`} loading="lazy" className="h-auto w-full rounded-[1.6rem]" />
              </div>
              <figcaption className="mt-4 px-1">
                <p className="font-medium text-white">{s.title}</p>
                <p className="mt-1 text-sm text-slate-400">{s.desc}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
      <Reveal className="mt-2">
        <p className="text-center text-xs uppercase tracking-[0.2em] text-slate-500">Faites défiler pour explorer l'application →</p>
      </Reveal>
    </div>
  );
}
